<template>
    <v-layout wrap row>
      <v-expansion-panel class="child-expansion thin-border-bottom hideExpansion elevation-0 py-0 px-0 rounded-3 mb-0" style="position:relative">
          <v-expansion-panel-content>
            <div slot="header">
              <v-layout wrap row>
                <v-flex xs12 lg5 :style="$vuetify.breakpoint.mdAndDown && 'width: calc(100% - 90px)!important; display:inline-block; float:left; flex-basis:initial !important'">
                  <span class="opacity-54" style="display:block;">{{taskType}}</span>
                  <h3 style="position:relative;" class="text-truncate">{{taskName}}</h3>
                  <div class="hidden-lg-and-up mt-1" style="width:100%; float:left">
                    <h4 class="d-inline-block mr-2" style="vertical-align:middle">
                      {{scheduledType}}
                      <span class="imminent" style="font-weight:700">{{formattedTime}}</span>
                    </h4>
                  </div>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex
                  xs12 lg7 class="mr-0 mt-0 text-xs-right"
                  :style="$vuetify.breakpoint.mdAndDown && 'width:90px !important; display:inline-block; flex-basis:initial !important'"
                  style="height:42px;">
                  <div class="hidden-md-and-down" style="display:inline-block">
                    <h4 class="d-inline-block mr-2" style="vertical-align:middle">
                      {{scheduledType}}
                      <span v-if="!pastDue" style="font-weight:700">{{formattedTime}}</span>
                      <span v-if="pastDue" class="overdue" style="font-weight:700">{{formattedTime}}</span>
                    </h4>
                  </div>
                  <UserAvatar
                    v-if="assignedUser"
                    avatarOnly
                    :userId="assignedUser.id"
                    :avatarURL="assignedUser.avatarUrl"
                    :name="assignedUser.displayName"
                    size="30px">
                  </UserAvatar>
                  <div class="header-actions d-inline-block" style="margin-top:3px;">
                    <v-tooltip top color="secondary">
                      <template v-slot:activator="{ on }">
                        <span class="d-inline-block" v-on="on">
                          <v-btn
                            v-if="hasPermissionToExecute"
                            @click.stop :ripple="false" icon @click="toggleComplete()"
                            class="ma-0 mr-0 pa-0 ml-0 hidden-md-and-down">
                            <v-icon v-if="!isComplete && taskType === 'Manual'" color="secondary">panorama_fish_eye</v-icon>
                            <v-icon v-if="isComplete && taskType === 'Manual'" color="success">check_circle</v-icon>
                            <v-icon v-if="taskType === 'Automation'" :color=" isComplete ? 'success' : 'secondary'">play_circle_filled</v-icon>
                          </v-btn>
                        </span>
                      </template>
                      <span v-if="taskType === 'Manual'">{{isComplete ? 'Complete' : 'Mark as complete'}}</span>
                      <span v-else>{{isComplete ? 'Re-run Task' : 'Run task'}}</span>
                    </v-tooltip>
                   <CaseTaskRunHistory :task="task" ></CaseTaskRunHistory>
                    <CaseTaskActionMenu
                      :task="task"
                      v-on:delete-task="dialogTaskDelete = true"
                      v-on:view-history="viewHistory()"
                      v-on:execute-task="executeTask()">
                    </CaseTaskActionMenu>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-container ma-0 px-0 pb-4 pt-2>
              <v-flex xs12 md6 mt-0>
              <v-text-field
                box
                v-model="taskName"
                :readonly="taskTemplate"
                label="Task name">
              </v-text-field>
              <v-textarea
                box
                v-model="taskDesc"
                :readonly="taskTemplate"
                label="Task description">
              </v-textarea>
            </v-flex>
            <v-flex ma-0 pa-0>
              <h4 class="pb-1">Schedule</h4>
              <v-layout row>
                  <v-autocomplete
                    clearable
                    clear-icon="cancel"
                    box dense class="pr-2"
                    label="Schedule Type"
                    v-model="scheduledType"
                    :items="scheduleItems"
                    append-icon="keyboard_arrow_down"
                    style="max-width:200px"
                    >
                  </v-autocomplete>
                  <DateField
                    v-if="scheduledType"
                    :field="{ name: scheduledType }"
                    :data="task.scheduledTime"
                    v-on:update-item="updateSchedule">
                  </DateField>
                  <v-flex mx-4></v-flex>
                  <v-flex v-if="!scheduledType" mx-4></v-flex>
              </v-layout>
            </v-flex>
            <v-layout wrap>
              <v-flex xs12 ma-0 pa-0>
                <h4 class="pb-1">Assign to a team/user</h4>
                <v-flex xs12 md6 mt-2>
                  <v-autocomplete
                    box dense
                    label="Select a team" no-data-text="Nothing matching your search"
                    v-model="assignedTeamId"
                    :items="allTeams"
                    append-icon="keyboard_arrow_down"
                    item-text="displayName" item-value="id">
                    <template slot="selection" slot-scope="data">
                      <v-chip
                        class="white--text chip-team share-chip" close
                        :class="(data.item.group)"
                        :selected="data.selected"
                        @input="assignedTeamId = null; assignedUserId = null;"
                        color="secondary">
                        <v-avatar style="opacity:1;"><v-icon dark small>people</v-icon></v-avatar>
                        {{data.item.displayName}}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-flex>
              <v-flex xs12 ma-0 pa-0 v-if="assignedTeamId">
                <h4 class="pb-1">Select a specific user from this team</h4>
                <v-layout wrap>
                  <v-flex xs12 md6 mt-2>
                    <v-autocomplete
                      box dense
                      label="Select a user" no-data-text="Nothing match your search"
                      v-model="assignedUserId"
                      :items="teamMembers"
                      item-text="displayName" item-value="id"
                      append-icon="keyboard_arrow_down">
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          class="white--text share-chip" close
                          :selected="data.selected"
                          :class="(data.item.group)"
                          @input="assignedUserId = null;"
                          color="secondary">
                          <v-avatar v-if="data.item.avatar"> <img :src="data.item.avatar"/></v-avatar>
                          <v-avatar v-if="data.item.avatar == false">{{data.item.initials}}</v-avatar>
                          <v-avatar v-if="data.item.group == 'chip-team'" style="opacity:1;"><v-icon dark small>people</v-icon></v-avatar>
                          {{ data.item.displayName }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-btn class="ml-0" color="success" :disabled="!taskChanged" @click="updateTask()">Save Changes</v-btn>
              <v-btn v-if="!taskTemplate" color="error" v-on:click="dialogTaskDelete = true">Delete Task</v-btn>
            </v-flex>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
          <v-dialog v-model="dialogTaskDelete" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-2">
          <h2>Are you sure you want to delete this task?</h2>
        </v-card-title>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn @click="deleteTask()" color="error">Yes, delete this task</v-btn>
          <v-btn @click="dialogTaskDelete = false" color="secondary">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-layout>
</template>

<script>
import CaseTaskActionMenu from "@/components/cases/case-edit/CaseTaskActionMenu"
import CaseTaskRunHistory from "@/components/cases/case-edit/CaseTaskRunHistory"
import DateField from "@/components/cases/case-elements/DateField"
import UserAvatar from "@/components/Users/UserAvatar.vue"
import Helpers from '@/helpers.js'
import { mapState } from "vuex"

export default {
  name: "CaseTaskItem",
  props: { task: { type: Object, required: true }, index: { type: Number, required: true } },
  components: { CaseTaskActionMenu, DateField, UserAvatar, CaseTaskRunHistory },
  data: () => ({
    dialogRunTaskParameters: false,
    dialogTaskDelete: false,
    taskChanged: false,
    taskMenu: false,
    scheduleItems: ["At", "By"]
  }),
  computed: {
    ...mapState({
      allUsers: state => (state && state.users && state.users.all) ? state.users.all : [],
      allTeams: state => (state && state.teams && state.teams.all) ? state.teams.all : [],
      timePref: state => (state && state.currentUser && state.currentUser.me &&
                            state.currentUser.me.preferences && state.currentUser.me.preferences.dateTimeFormat)
        ? state.currentUser.me.preferences.dateTimeFormat : "HH:MM, D MMM",
      caseId: state => state.cbroute.params.case_id,
      permissions: state => state.ui.grantedPermissions,
      caseTypeCode: state => state.caseTypes.current.code
    }),

    isComplete() {
      return this.task.currentStatus === "completed"
    },
    hasPermissionToExecute() {
      Helpers.hasPermission(this.permissions, "", this.caseTypeCode)
      return true
    },
    taskName: {
      get() { return this.task.name },
      set(newName) {
        this.taskChanged = true
        this.task.name = newName
      }
    },
    taskDesc: {
      get() { return this.task.description },
      set(newDesc) {
        this.taskChanged = true
        this.task.description = newDesc
      }
    },
    scheduledType: {
      get() {
        if (this.task.scheduledType) {
          if (this.task.scheduledType === "at") { return "At" }
          if (this.task.scheduledType === "by") { return "By" }
        }
        return null
      },
      set(newType) {
        this.taskChanged = true
        if (newType) {
          this.task.scheduledType = newType.toLowerCase()
        } else {
          this.task.scheduledType = null
        }
      }
    },
    formattedTime() {
      if (this.task.scheduledTime) {
        return Helpers.formatDate(this.task.scheduledTime, this.timePref)
      } else {
        return ""
      }
    },
    pastDue() {
      if (this.task.scheduledTime) {
        return new Date(this.task.scheduledTime) < new Date()
      } else {
        return false
      }
    },
    taskColour() {
      if (this.pastDue) { return "error" } else { return "info" }
    },
    taskTemplate: {
      get() { return this.task.templated }
    },
    taskType: {
      get() {
        let type = "Manual"
        if (this.task.task && this.task.task.actionType && this.task.task.actionType !== "ManualTask") {
          type = "Automation"
        }
        return type
      }
    },
    assignedTeamId: {
      get() {
        if (this.task.assignedToTeam) { return this.task.assignedToTeam.id } else { return null }
      },
      set(teamId) {
        this.task.assignedToTeam = this.allTeams.find((t) => t.id === teamId)
        this.taskChanged = true
      }
    },
    assignedUserId: {
      get() {
        if (this.task.assignedToUser) { return this.task.assignedToUser.id } else { return null }
      },
      set(userId) {
        this.task.assignedToUser = this.allUsers.find((u) => u.id === userId)
        this.taskChanged = true
      }
    },
    assignedUser() {
      let user
      if (this.assignedUserId) {
        user = this.allUsers.find((currentUser) => (parseInt(currentUser.id) === parseInt(this.assignedUserId)))
      }
      return user
    },
    teamMembers() {
      const members = []
      if (this.assignedTeamId) {
        const userIds = this.allUsers.map(user => user.id)
        const selectedTeam = this.allTeams.find((t) => t.id === this.assignedTeamId)
        if (selectedTeam && selectedTeam.users) {
          selectedTeam.users.forEach(user => {
            const userIndex = userIds.indexOf(user.id)
            members.push(this.allUsers[userIndex])
          })
        }
      }
      return members
    }
  },
  methods: {
    async toggleComplete() {
      this.exectueTask()
    },
    async updateTask() {
      let taskPos = this.index
      if (this.task.position) { taskPos = this.task.position }
      const updateTask = {
        id: this.task.id,
        name: this.taskName,
        description: this.taskDesc,
        position: taskPos
      }
      // Schedule
      const taskSchedule = {}
      if (this.scheduledType || this.scheduledTime) {
        taskSchedule.scheduledBy = this.scheduledType.toLowerCase()
        taskSchedule.scheduledTime = this.task.scheduledTime
      }
      if (taskSchedule.scheduledBy || taskSchedule.scheduledTime) { updateTask.taskSchedule = taskSchedule }
      // Team/User
      const assignedTo = {}
      if (this.assignedTeamId && this.assignedTeamId) { assignedTo.assignedToTeamId = this.assignedTeamId }
      if (this.assignedUserId && this.assignedUserId) { assignedTo.assignedToUserId = this.assignedUserId }
      if (assignedTo.assignedToTeamId) { updateTask.assignedTo = assignedTo }
      await this.$store.dispatch("updateCaseTask", updateTask)
      this.taskChanged = false
    },
    deleteTask() {
      this.dialogTaskDelete = false
      this.$store.dispatch("deleteCaseTask", this.task.id)
    },
    updateSchedule(value) {
      this.task.scheduledTime = value.data
      this.taskChanged = true
    },
    viewHistory() {
      console.log("Show task history... ", this.task)
    },
    async exectueTask() {
      const result = await this.$store.dispatch("executeCaseTask", this.task.id)
      if (result) {
        this.$store.dispatch("getCurrentlySelectedCase", { caseId: this.caseId })
      }
    }
  }

}
</script>
